module.exports = __webpack_public_path__ + "img/icon-pin.fbfa5ab2.svg";